import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from "../features/api/apiSlice";
import cartReducer from "../features/cartProducts/cartSlice";
import funReducer from "../features/someFunctionality/funSlice";
import wishlistReducer from "../features/wishlist/wishlistSlice";
import filterReducer from "../features/filterSlice/filterSlice";
import checkoutReducer from "../features/checkout/checkoutSlice";
import userReducer from "../features/user/userSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    cartProducts: cartReducer,
    someFun: funReducer,
    wishlist: wishlistReducer,
    filter: filterReducer,
    checkout: checkoutReducer,
    user: userReducer,
  },
  middleware: (getDefultMiddlewares) => getDefultMiddlewares().concat(apiSlice.middleware),
});
